<template>
    <div>
        <header-portrate />

        <div>
            <bread-crumbs :items="items"></bread-crumbs>

            <tabs-comp :tabs="tabs" />

            <v-tabs center>
                <v-tab>{{lang.main_print_settings}}</v-tab>
                <v-tab>{{lang.invoice_print_settings}}</v-tab>
                <v-tab>{{lang.quotation_print_settings}}</v-tab>
                <v-tab>{{lang.job_card_print_settings}}</v-tab>
                <v-tab-item><PrintingSettings /></v-tab-item>
                <v-tab-item><PrintingInvoiceSettings /></v-tab-item>
            </v-tabs>
        </div>
        <Footer />
    </div>
</template>

<script>

import axios from 'axios'
import headerPortrate from '@/components/Header-Portrate.vue'
import breadCrumbs from '@/components/breadCrumbs.vue'
import tabsComp from '@/components/tabsComp.vue'
import Footer from '@/components/Footer.vue'
import PrintingSettings from '@/components/printing_settings.vue'
import PrintingInvoiceSettings from '@/components/printing_invoice_settings.vue'
import { getVisibleTabsForRoute } from '@/menu/menuService'

export default{
    name: 'printing',
    components: {headerPortrate,breadCrumbs,tabsComp,Footer,PrintingSettings,PrintingInvoiceSettings},
    data() {
        return {
            printings: {
                header: '',
                invoice_body: '',
                voucher_body: '',
                card_body: '',
                footer: '',
                pos_header: '',
                pos_footer: '',
                ex_footer: '',
            },
            printing: {
                header: '',
                invoice_body: '',
                voucher_body: '',
                card_body: '',
                footer: '',
                ex_footer: '',
                pos_header: '',
                pos_footer: '',
            },
        }
    },
    computed: {

        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        items: function(){
            return  {
                text: this.lang.customers,
                disabled: true,
                href: '/clientList',
            };
        },
        tabs: function() {

            return getVisibleTabsForRoute(this.$store.getters['state'], this.lang, this.$route.path);

        },
    },
    methods: {
        view(){
            window.open("../api/print.php?test","_blank")
        },
        save(){
            const post = new FormData();
            post.append('type', "SavePrint");
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("auth" , this.$cookies.get(this.$COOKIEPhase));
            post.append("auth" , this.$cookies.get(this.$COOKIEPhase));
            post.append('data[header]',btoa(unescape(encodeURIComponent(this.printing.header))));
            post.append('data[invoice_body]',btoa(unescape(encodeURIComponent(this.printing.invoice_body))));
            post.append('data[voucher_body]',btoa(unescape(encodeURIComponent(this.printing.voucher_body))));
            post.append('data[card_body]',btoa(unescape(encodeURIComponent(this.printing.card_body))));
            post.append('data[footer]',btoa(unescape(encodeURIComponent(this.printing.footer))));
            post.append('data[ex_footer]',btoa(unescape(encodeURIComponent(this.printing.ex_footer))));
            post.append('data[pos_footer]',btoa(unescape(encodeURIComponent(this.printing.pos_footer))));
            post.append('data[pos_header]',btoa(unescape(encodeURIComponent(this.printing.pos_header))));
            axios.post(
                this.$SAMCOTEC.r_path, post
            ).then(() =>{

                this.preparedata();
            })
        },
        preparedata(){
            const post = new FormData();
            post.append('type', "PrintSet");
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("auth" , this.$cookies.get(this.$COOKIEPhase));
            post.append('data[header]',this.printing.header);
            post.append('data[invoice_body]',this.printing.invoice_body);
            post.append('data[voucher_body]',this.printing.voucher_body);
            post.append('data[card_body]',this.printing.card_body);
            post.append('data[footer]',this.printing.footer);
            post.append('data[ex_footer]',this.printing.ex_footer);
            axios.post(
                this.$SAMCOTEC.r_path, post
            ).then((response) =>{
                // // console.log(response.data)
                this.printings = response.data.results.data;
                Object.keys(response.data.results.data).forEach(key => {
                    this.printing[key] = decodeURIComponent(escape(atob(response.data.results.data[key])))
                })
            })
        },
    },
    created() {
        this.preparedata();
    },
}
</script>